import { getOrCreateGuestId } from './guest';

let activeUserId: string | null = null;

export function setActiveUserId(id: string): void {
  activeUserId = id;
}

export function clearActiveUserId(): void {
  activeUserId = null;
}

export function getActiveUserId(): string {
  if (activeUserId) return activeUserId;
  return getOrCreateGuestId();
}